import { Navigate, useLocation } from 'react-router-dom'
import { useAuth } from '../contexts/AuthContext'
import { roleStartPath } from '../utils/constants'

/** /admin bzw. /editor → rollenrichtige Startseite (bzw. bereichseigener Login,
 *  falls anonym — F2-Split: /admin/login bzw. /editor/login). Während des
 *  Mount-Bootstraps (`status==='loading'`) noch nichts rendern/umleiten. */
export function IndexRedirect() {
  const { session, status } = useAuth()
  const location = useLocation()
  if (status === 'loading') return null
  if (!session) {
    const loginPath = location.pathname.startsWith('/admin') ? '/admin/login' : '/editor/login'
    return <Navigate to={loginPath} replace />
  }
  return <Navigate to={roleStartPath(session.role)} replace />
}
